import { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useLogger } from '../services/LogService';
import { AppContext } from '../state/AppContextProvider';
import { ActionType } from '../state/GlobalState';

interface MenuRule {
  route: string;
  matcher: (route: string) => boolean;
}

const MENU_ROUTES: MenuRule[] = [
  { route: '/house', matcher: (route) => route.startsWith('/house') },
  {
    route: '/news',
    matcher: (route) => ['/news', '/events'].some((it) => route.startsWith(it)),
  },
  { route: '/services', matcher: (route) => route.startsWith('/services') },
];

export function useMenuRoutes() {
  const logger = useLogger('Menu');

  const history = useHistory();

  const [menuRoute, setMenuRoute] = useState('');

  const { state, dispatch } = useContext(AppContext);

  const location = useLocation();

  useEffect(() => {
    dispatch({
      type: ActionType.SetCurrentPath,
      payload: {
        previousPath: state.currentPath,
        currentPath: location.pathname,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return history.listen((loc) => {
      const currRoute = loc.pathname;
      logger.debug('Current route: ' + currRoute);

      const nextRoute = MENU_ROUTES.find((it) => it.matcher(currRoute));
      if (nextRoute) {
        logger.info('Menu route: ' + nextRoute.route);
        setMenuRoute(nextRoute.route);
      } else {
        setMenuRoute(currRoute);
      }

      dispatch({
        type: ActionType.SetCurrentPath,
        payload: {
          previousPath: state.currentPath,
          currentPath: currRoute,
        },
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return { menuRoute: menuRoute };
}
